import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    validation() {
      if (!this.proxy.title) {
        return false
      }

      if (!this.proxy.ServerId) {
        return false
      }

      if (!this.proxy.CredentialsId) {
        return false
      }

      return true
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  render
}
